import '@/features/documentation/styles/support-request.css'
import React from 'react';
import { Modal, Form, Input } from 'antd';

const { TextArea } = Input;

export default function SupportRequest(props) {

    const handleOk = () => {
        props.handleOk(false);
    };
    const handleCancel = () => {
        props.setIsOpen(false);
    };

    return (
        <div>
            <Modal
                open={props.isOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                title={<div style={{ fontSize: "25px" }}>OPTUNE.ai Support Request</div>}
                className='support-request-modal'
                centered
            >
                <Form layout="vertical">
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            {
                                required: true,
                                message: 'email is required',
                            },
                        ]}
                    >
                        <Input placeholder='enter email' />
                    </Form.Item>
                    <Form.Item
                        name="topic"
                        label="Topic"
                        rules={[
                            {
                                required: true,
                                message: 'topic is required',
                            },
                        ]}
                    >
                        <Input placeholder='enter email' />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label={<div>Description</div>}
                        rules={[
                            {
                                required: true,
                                message: 'description is required',
                            },
                        ]}
                    >
                        <TextArea
                            placeholder='enter description'
                            rows={4}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
